import * as React from "react";

import { useContext } from "react";
import { useTheme, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import {
  usePickerLayout,
  pickersLayoutClasses,
  PickersLayoutRoot,
  PickersLayoutContentWrapper,
} from "@mui/x-date-pickers/PickersLayout";
import { AppContext } from "../../contextProviders/AppContext";
import { add, set, getHours, isToday } from "date-fns";
import { translation } from "../Dictionary";
import { Box } from "@mui/system";
import { useRef } from "react";

function CustomLayout(props) {
  const { toolbar, tabs, content, actionBar } = usePickerLayout(props);

  return (
    <PickersLayoutRoot
      ownerState={props}
      sx={{
        overflow: "auto",
        [`.${pickersLayoutClasses.actionBar}`]: {
          gridColumn: 1,
          gridRow: 2,
        },
        [`.${pickersLayoutClasses.toolbar}`]: {
          gridColumn: 2,
          gridRow: 1,
        },
      }}
    >
      {toolbar}

      <PickersLayoutContentWrapper
        className={pickersLayoutClasses.contentWrapper}
      >
        {tabs}
        {actionBar}

        {content}
      </PickersLayoutContentWrapper>
    </PickersLayoutRoot>
  );
}

export default function DatePickerFixedTimeframe({ getMinimumDate }) {
  const {
    selectedCompany,
    language,
    reservationStart,
    reservationReturn,
    FEATURE_PREDETERMINED_RESERVATION_RETURNTIME,
    setSelectedDateRange,
    businessHourDates,
    selectedTimeFrame,
    isDisabled,
    selectedDateRange,
    selectedPicker,
    setSelectedPicker,
  } = useContext(AppContext);
  const containerRef = useRef();
  //

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleCloseCalendar = () => {
    if (!reservationStart) {
      setSelectedPicker("startTime");
    } else {
      setSelectedPicker(null);
    }
  };
  const handleChangeDate = (newValue) => {
    // single day datepicker doesnt return an array, and this mixed up
    // logic used with daterange pickers
    const dateToArray = [newValue, newValue];
    if (!reservationStart) {
      // businessHourDates is the open hours of the day, determined by the selectedDateRange
      const returnTime = () => {
        if (FEATURE_PREDETERMINED_RESERVATION_RETURNTIME) {
          return add(newValue, { hours: selectedTimeFrame });
        }

        return newValue;
      };
      const nextHourOfToday = getHours(new Date()) + 1;

      // if selected start date is the current day, check for the time settings
      if (
        businessHourDates(dateToArray)?.start.openingTime.getTime() >
          newValue.getTime() &&
        isToday(newValue)
      ) {
        setSelectedDateRange([
          set(newValue, { hours: nextHourOfToday }),
          set(newValue, { hours: nextHourOfToday + 1 }),
        ]);
      } else {
        setSelectedDateRange([
          set(newValue, {
            hours: getHours(businessHourDates(dateToArray).start.openingTime),
          }),
          returnTime(),
        ]);
      }
    } else {
      const returnTime = () => {
        if (FEATURE_PREDETERMINED_RESERVATION_RETURNTIME) {
          return add(newValue, { hours: selectedTimeFrame });
        }

        return set(newValue, {
          hours: reservationReturn.getHours(),
          minutes: reservationReturn.getMinutes(),
        });
      };

      setSelectedDateRange([
        set(newValue, {
          hours: reservationStart.getHours(),
          minutes: reservationStart.getMinutes(),
        }),
        returnTime(),
      ]);
    }
  };

  return (
    <Box ref={containerRef} width={"150px"}>
      <DatePicker
        minDate={getMinimumDate()}
        shouldDisableDate={isDisabled}
        label={translation.get(language, "Date label")}
        disabled={!selectedCompany}
        disableMaskedInput
        PaperProps={{
          square: true,
          sx: {
            borderRadius: "17px",
            marginTop: "12px",
          },
        }}
        onOpen={(e) => {
          setAnchorEl(e.currentTarget);
          setSelectedPicker("calendar");
        }}
        open={selectedPicker === "calendar"}
        onClose={() => handleCloseCalendar}
        disablePast
        value={selectedDateRange[0]}
        onChange={(newValue) => {
          // newValue = date instead of an array [date, date],
          //because DatePicker is used instead of DaterangePicker
          console.log("newValue", newValue);

          handleChangeDate(newValue);
          setSelectedPicker("startTime");
        }}
        slots={{
          layout: CustomLayout,
          textField: CustomTextField,
        }}
        PopperProps={{
          placement: "bottom-end",
          anchorEl: anchorEl,
        }}
      />
    </Box>
  );
}

const CustomTextField = (props) => {
  const theme = useTheme();
  const { setSelectedPicker } = useContext(AppContext);
  return (
    <Box onClick={() => setSelectedPicker("calendar")}>
      <TextField
        {...props}
        InputProps={{
          ...props.InputProps,
          disableUnderline: true,
          style: {
            borderRadius: "10px",
            backgroundColor: "transparent",
            border: "none",
          },
          endAdornment: null,
        }}
        inputProps={{
          ...props.inputProps,
          readOnly: true,
          style: { cursor: "pointer" },
          placeholder: "",
        }}
        sx={{
          input: {
            color: theme.palette.primary.mainText,
            borderRadius: "10px",
            cursor: "pointer",
            transition: "150ms ease-in",
            "&:hover": {
              bgcolor: "rgba(0,0,0,0.05)",
              boxShadow: theme.shadows[2],
            },
          },
        }}
        variant="filled"
      />
    </Box>
  );
};
